var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "w-100" },
    [
      _c(
        "div",
        {
          staticClass: "container-fluid fixed-top w-100 px-0",
          attrs: { id: "nav-info", role: "navigation" }
        },
        [
          _c("interview-navi", { attrs: { navData: _vm.navData } }),
          _vm._v(" "),
          !(_vm.isAutoRC2Error && _vm.isHomeRC2Error)
            ? _c(
                "div",
                {
                  staticClass: "position-relative export-dropdown-col-checkout"
                },
                [
                  _c(
                    "div",
                    { staticClass: "select-box-col" },
                    [
                      _c("input-select", {
                        ref: _vm.exportDropdown.field_name,
                        attrs: {
                          fieldData: _vm.exportDropdown,
                          exportPDF: _vm.exportPDF
                        }
                      })
                    ],
                    1
                  )
                ]
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          class: {
            "quote-panel-open": _vm.quotePanelStatus,
            "quote-panel-close": !_vm.quotePanelStatus,
            bundle:
              _vm.flowType === "bundle" ||
              _vm.flowType === "cabundle" ||
              _vm.flowType === "rabundle"
          },
          attrs: { role: "main" }
        },
        [
          _c("div", { staticClass: "row no-gutters mx-0" }, [
            _c("div", { staticClass: "col" }, [
              _c("div", { staticClass: "row my-3" }, [
                _c(
                  "div",
                  {
                    staticClass: "col-12 col-xl-6 b-border-right pl-3 pr-4",
                    class: {
                      bound:
                        this.$store.getters.getHomeBindStatus &&
                        this.$store.getters.getHomeBindStatus.Status ===
                          "Success"
                    },
                    attrs: { id: "homeCol" }
                  },
                  [
                    _vm.getHomeCarrier &&
                    _vm.getHomeCarrier.carrier_type === "EZLYNXCARRIER"
                      ? _c("div")
                      : _vm.getHomeCarrier && _vm.showHomeForceBindMsg
                      ? _c(
                          "div",
                          [
                            _c("bundle-carrier-error", {
                              attrs: { errorData: _vm.homeForceBindMsg }
                            })
                          ],
                          1
                        )
                      : _vm.getHomeCarrier
                      ? _c("home-checkout")
                      : _c(
                          "div",
                          [
                            _c("bundle-carrier-error", {
                              attrs: { errorData: _vm.homeBundleCarrierError }
                            })
                          ],
                          1
                        )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "col-12 col-xl-6 pl-4 pr-3",
                    class: {
                      bound:
                        this.$store.getters.getAutoBindStatus &&
                        this.$store.getters.getAutoBindStatus.Status ===
                          "Success"
                    }
                  },
                  [
                    _vm.getAutoCarrier &&
                    _vm.getAutoCarrier.carrier_type === "EZLYNXCARRIER"
                      ? _c("div")
                      : _vm.getAutoCarrier && _vm.showAutoForceBindMsg
                      ? _c(
                          "div",
                          [
                            _c("bundle-carrier-error", {
                              attrs: { errorData: _vm.autoForceBindMsg }
                            })
                          ],
                          1
                        )
                      : _vm.getAutoCarrier
                      ? _c("auto-checkout")
                      : _c(
                          "div",
                          [
                            _c("bundle-carrier-error", {
                              attrs: { errorData: _vm.autoCundleCarrierError }
                            })
                          ],
                          1
                        )
                  ],
                  1
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _vm.showIndividualBindAlert
            ? _c(
                "div",
                {
                  staticClass:
                    "row justify-content-center b-fixed-row no-gutters",
                  class: { "margin-25": _vm.quotePanelStatus }
                },
                [
                  this.$store.getters.getHomeBindStatus &&
                  this.$store.getters.getHomeBindStatus.Status === "Success"
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "col-6 text-center bundle-policy-bound-alert"
                        },
                        [_vm._m(0)]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-6 text-center py-3" }, [
                    _vm.showPurchaseButton
                      ? _c(
                          "button",
                          {
                            staticClass: "btn btn-primary btn purchase-btn",
                            class: {
                              disabled: _vm.isAutoRC2Error || _vm.isHomeRC2Error
                            },
                            attrs: { type: "submit" },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.bundleSubmitProperty("submit")
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.submitButtonLabel))]
                        )
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  this.$store.getters.getAutoBindStatus &&
                  this.$store.getters.getAutoBindStatus.Status === "Success"
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "col-6 text-center bundle-policy-bound-alert"
                        },
                        [_vm._m(1)]
                      )
                    : _vm._e()
                ]
              )
            : _vm.showPurchaseButton
            ? _c(
                "div",
                {
                  staticClass: "form-row justify-content-center b-fixed-row",
                  class: { "margin-25": _vm.quotePanelStatus }
                },
                [
                  _c("div", { staticClass: "col-8 text-center" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary btn my-3",
                        attrs: { type: "submit" },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.bundleSubmitProperty("submit")
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.submitButtonLabel))]
                    )
                  ])
                ]
              )
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "confirm-policy-bind",
          attrs: {
            "hide-header": "",
            "hide-footer": "",
            "hide-header-close": "",
            "no-enforce-focus": ""
          }
        },
        [
          _c("Trap", [
            _c("div", { staticClass: "policy-confirmation-box" }, [
              _c("div", { staticClass: "policy-modal-message mb-3" }, [
                _c("div", [_vm._v(_vm._s(_vm.confirmMsg))])
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "policy-btn-box d-flex justify-content-between"
                },
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "mt-3 policy-btn-cancel",
                      attrs: { block: "" },
                      on: {
                        click: function($event) {
                          return _vm.closeRemoveModal("confirm-policy-bind")
                        }
                      }
                    },
                    [_vm._v("Cancel")]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      staticClass: "mt-3 policy-btn-confirm",
                      attrs: { block: "" },
                      on: {
                        click: function($event) {
                          return _vm.bundleSubmitProperty("confirm")
                        }
                      }
                    },
                    [_vm._v(" " + _vm._s(_vm.popupButtonLable))]
                  )
                ],
                1
              )
            ])
          ])
        ],
        1
      ),
      _vm._v(" "),
      _vm.showBoundAlert
        ? _c("form-alerts", {
            class: {
              "policy-bound-alert": true,
              "margin-25": _vm.quotePanelStatus
            },
            attrs: { pageData: _vm.policyBindError }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "p-3 m-0 rounded-0 text-left alert alert-warning border-bottom-0 border-left-0",
        attrs: { role: "alert", "aria-atomic": "true" }
      },
      [
        _c("p", [
          _c("strong", [_vm._v("Policy Bound:")]),
          _vm._v(
            "This policy has been completed and bound. Any attempted changes to this policy will not be saved. Contact your manager if this policy was saved with incorrect information."
          )
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "p-3 m-0 rounded-0 text-left alert alert-warning border-bottom-0 border-right-0",
        attrs: { role: "alert", "aria-atomic": "true" }
      },
      [
        _c("p", { staticClass: "m-0" }, [
          _c("strong", [_vm._v("Policy Bound:")]),
          _vm._v(
            "This policy has been completed and bound. Any attempted changes to this policy will not be saved. Contact your manager if this policy was saved with incorrect information."
          )
        ])
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-70fb39d4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70fb39d4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/interview/shared/BundleCheckout.vue
// module id = null
// module chunks = 